import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-200 inline-flex items-center justify-center';
  const variants = {
    primary: 'bg-[var(--viridia-green)] text-white hover:bg-[var(--deep-teal)] shadow-lg hover:shadow-xl',
    secondary: 'bg-[var(--jet-black)] text-white hover:bg-[var(--graphite-gray)] shadow-lg hover:shadow-xl',
    outline: 'border-2 border-[var(--viridia-green)] text-[var(--viridia-green)] hover:bg-[var(--viridia-green)] hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button onClick={onClick} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} data-id="element-279">
      {children}
    </button>;
}